import * as types from "../mutation-types";

function initialState() {
    return {
        includeContributionAndWithdrawal: false,
        liquidateOnEndDate: false,
        subSequents: []
    };
}

const state = {
    ...initialState()
};

const getters = {
    getPreferenceSubSequentSetting(state, getters, rootState) {
        return rootState.settings.preferences.subSequentSetting;
    },
    hasInitialContribution(state, getters, rootState) {
        return rootState.holdings.securities.length > 0;
    },
    contributionRecordsNum(state, getters) {
        const recordsNum = getters.hasInitialContribution ? 1 : 0;
        return recordsNum + state.subSequents.filter(i => i.type === 12 && i.visible).length;
    },
    withdrawalRecordsNum(state) {
        return state.subSequents.filter(i => i.type === 22 && i.visible).length;
    },
    subSequentTypes() {
        return [
            {
                typeId: 12,
                text: "Contribution",
                labelId: "portfolio_transactions_type_contribution"
            },
            {
                typeId: 22,
                text: "Withdrawal",
                labelId: "portfolio_transactions_type_withdrawal"
            }
        ];
    },
    frequencies() {
        return [
            {
                id: 1,
                text: "Monthly",
                labelId: "COMMON_FREQUENCY_MONTHLY"
            },
            {
                id: 3,
                text: "Quarterly",
                labelId: "COMMON_FREQUENCY_QUARTERLY"
            },
            {
                id: 6,
                text: "Semi-Annually",
                labelId: "COMMON_FREQUENCY_SEMI_ANNUALLY"
            },
            {
                id: 12,
                text: "Annually",
                labelId: "COMMON_FREQUENCY_ANNUALLY"
            },
            {
                id: 99,
                text: "One Time",
                labelId: "portfolio_transactions_frequency_one_time"
            }
        ];
    },
    subSequentSetting(state) {
        if (!state.includeContributionAndWithdrawal) {
            return undefined;
        }
        return {
            include: state.includeContributionAndWithdrawal,
            liquidateOnEndDate: state.liquidateOnEndDate,
            subSequents: state.subSequents
        };
    }
};

const mutations = {
    [types.SET_SUB_SEQUENT_SETTING](state, data) {
        if (data) {
            state.includeContributionAndWithdrawal = data.include;
            if (data.subSequents) {
                state.subSequents = data.subSequents;
            } else {
                state.subSequents = [];
            }
            state.liquidateOnEndDate = data.liquidateOnEndDate || false;
        } else {
            state.includeContributionAndWithdrawal = false;
        }
    },
    [types.SET_INCLUDE_CONTRIBUTION_AND_WITHDRAWAL](state, data) {
        state.includeContributionAndWithdrawal = data;
    },
    [types.SET_LIQUIDATE_ON_END_DATE](state, data) {
        state.liquidateOnEndDate = data;
    },
    [types.SET_SUB_SEQUENTS](state, data) {
        state.subSequents = data || [];
    },
    [types.RESET](state) {
        const initialData = initialState();
        Object.keys(initialData).forEach(key => {
            state[key] = initialData[key];
        });
    }
};

export default {
    state,
    getters,
    mutations
};
